// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listProfile' }],
    name: 'get-all-profiles',
    sort: ['+name'],
});
